import React from 'react';
import { Link } from 'react-router-dom';
import './../assets/css/payment-errorpage.css'; // Optional: Import custom CSS

const PaymentErrorPage = ({ errorMessage }) => {
    return (
        <div className="error-page">
            <h1>Error</h1>
            <p>{errorMessage || "Something went wrong. Please try again later."}</p>
            <div className="error-actions">
                <Link to="/" className="button error-button">
                    Go to Home
                </Link>
            </div>
        </div>
    );
};

export default PaymentErrorPage;